export default {
    RUMAH: 'RUMAH',
    KERJA: 'KERJA',
    PRAKTEK_PRIBADI: 'PRAKTEK_PRIBADI',
    KLINIK: 'KLINIK',
    RUMAH_BERSALIN: 'RUMAH_BERSALIN',
    RUMAH_SAKIT: 'RUMAH_SAKIT'
}
